// extracted by mini-css-extract-plugin
module.exports = {"leftSideContentDesktop":"PageLecture__leftSideContentDesktop__TXjDu","leftSideContentMobile":"PageLecture__leftSideContentMobile__2ao8P"};